import React from 'react';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import './LinkButton.css';

const LinkButton = ({ text, link, floated }) => {
  return (
    <Link to={link}>
      <Button className="LinkButton btn-animated" floated={floated ? 'left' : floated}>{text}</Button>
    </Link>
  );
};

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/UtilityComponents/LinkButton/index.js